import { render, staticRenderFns } from "./jxsWill.vue?vue&type=template&id=f01f8ac2&"
import script from "./jxsWill.vue?vue&type=script&lang=js&"
export * from "./jxsWill.vue?vue&type=script&lang=js&"
import style0 from "./jxsWill.vue?vue&type=style&index=0&id=f01f8ac2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports